import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';
import { TRIGGER_CHART_TYPES } from '/src/features/goals/constants';

export const goalSelectedDatesAtom = atomWithDefault(() => {
  const params = new URLSearchParams(window.location.search);
  const dateRange = params.get('date_range') || 'last 7 days';

  if (dateRange.includes(',')) {
    const [startDate, endDate] = dateRange.split(',').map(Number);
    return {
      special: null,
      startDate,
      endDate,
    };
  } else if (dateRange.length) {
    return {
      special: dateRange,
      startDate: null,
      endDate: null,
    };
  } else {
    return {
      special: 'last 7 days',
      startDate: null,
      endDate: null,
    };
  }
});

export const goalDetailSelectedTriggerType = atom(TRIGGER_CHART_TYPES.SEPARATE);
